import Service from "./Service";

class ClaimApiService extends Service {
  constructor() {
    super("api");
  }

  async create(payload) {
    let result = await this.post(`Claims`, payload, (status, data) => {
      return { status, data };
    });
    return result;
  }

  async getAll(payload) {
    let result = await this.post(`Administration/GetClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getAccountingReport(payload) {
    let result = await this.post(`Administration/GetAccountingReport`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getTotalReimbursementSEK(payload) {
    let result = await this.post(`Administration/GetTotalReimbursementSEK`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getCurrentApproveClaimJob() {
    let result = await this.get(`Administration/GetCurrentApproveClaimJob`, (status, data) => {
      return data;
    });
    return result;
  }

  async getApproveClaimJobById(id) {
    let result = await this.getWithoutTracker(`Administration/GetApproveClaimJobById?jobId=${id}`, (status, data) => {
      return data;
    });
    return result;
  }

  async approveClaims(payload) {
    let result = await this.post(`Administration/ApproveClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getClaimsForApprove(payload) {
    let result = await this.post(`Administration/getClaimsForApprove`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getApproveClaims(payload) {
    let result = await this.post(`Administration/GetApproveClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getFraudReport(payload) {
    let result = await this.post(`Administration/GetFraudReport`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getFraud() {
    let result = await this.get(`Administration/GetFraud`, (status, data) => {
      return data;
    });
    return result;
  }

  async getClaimStatus() {
    let result = await this.get(`Administration/GetClaimStatus`, (status, data) => {
      return data;
    });
    return result;
  }

  async exportSUSFile(payload) {
    let result = await this.post(`Administration/ExportSusFile`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async exportAccountingReport(payload) {
    let result = await this.post(`Administration/ExportAccountingReport`, payload, (status, data) => {
      return data;
    });
    return result;
  }
}

export default new ClaimApiService();
